import { createSlice } from '@reduxjs/toolkit';

import { resetAll } from 'store/reset';

const initialState = {
  intendedRoute                   : '',
  isSettingUpParticipantTasks     : false,
  participantTasksSetupFailed     : false,
  snackbar                        : {
    open       : false,
    showAlways : false,
    type       : 'success',
    message    : '',
  },
};

const applicationSlice = createSlice({
  name     : 'application',
  initialState,
  reducers : {
    setIntendedRoute : (state, action) => {
      state.intendedRoute = action.payload;
    },
    setSettingUpParticipantTasks : (state, action) => {
      state.isSettingUpParticipantTasks = action.payload;
    },
    setParticipantTasksSetupFailed : (state, action) => {
      state.participantTasksSetupFailed = action.payload;
    },
    openSnackbar : (state, action) => {
      state.snackbar.type = action.payload.type;
      state.snackbar.message = action.payload.message;
      state.snackbar.open = true;
      state.snackbar.showAlways = action.payload.showAlways;
    },
    closeSnackbar : (state) => {
      state.snackbar.open = false;
      state.snackbar.showAlways = false;
      state.snackbar.message = '';
      state.snackbar.type = 'success';
    },
  },
  extraReducers : (builder) =>
    builder.addCase(resetAll.type, () => initialState),
});

export const {
  setIntendedRoute,
  setSettingUpParticipantTasks,
  setParticipantTasksSetupFailed,
  openSnackbar,
  closeSnackbar,
} = applicationSlice.actions;

export default applicationSlice;
